<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-card
    class="mt-1"
    elevation="0"
  >
    <div class="d-flex align-center justify-center">
      <div>ReservationId</div>
      <v-spacer />
      <div>{{ reservationInfo.reservationId }}</div>
    </div>
    <div class="d-flex align-center justify-center">
      <div>First Name</div>
      <v-spacer />
      <div>{{ reservationInfo.firstName }}</div>
    </div>
    <div class="d-flex align-center justify-center">
      <div>Last Name</div>
      <v-spacer />
      <div>{{ reservationInfo.lastName }}</div>
    </div>
    <div class="d-flex align-center justify-center">
      <div>Email</div>
      <v-spacer />
      <div>{{ reservationInfo.emailDisplay }}</div>
    </div>
    <div class="d-flex align-center justify-center">
      <div>Tel</div>
      <v-spacer />
      <div>{{ reservationInfo.tel }}</div>
    </div>
  </v-card>
</template>

<script>

const DefaultMenuInfo = {
  reservationId: '',
  firstName: '',
  lastName: '',
  emailDisplay: '',
  tel: '',
  note: ''
}
export default {
  name: 'ReservationInfoBlock',
  data: function () {
    return {
    }
  },
  props: {
    reservationInfo: {
      type: Object,
      default: () => DefaultMenuInfo
    }
  }
}
</script>

<style scoped>

</style>
